import {
  DEFAULT_VARIANT,
  DEFAULT_COLOR,
  DEFAULT_SIZE,
} from '@upright/ui/common/generic/components/button/Button.constants';
import { VisuallyHidden } from '@upright/ui/common/generic/components/visually-hidden';
import { type InternalProps } from './Button.types';
import { ButtonContent } from './Button.blocks';
import { forwardRef, type ForwardedRef } from 'react';
import { Button as ReactAriaButton, composeRenderProps } from 'react-aria-components';
import clsx from 'clsx';

import styles from './Buttons.module.css';

export const Button = forwardRef(function _Button(
  {
    variant = DEFAULT_VARIANT,
    size = DEFAULT_SIZE,
    color = DEFAULT_COLOR,
    startIcon,
    endIcon,
    children: childrenFromProps,
    type = 'button',
    isContentVisuallyHidden,
    ...rest
  }: InternalProps,
  ref: ForwardedRef<HTMLButtonElement>,
) {
  return (
    <ReactAriaButton
      {...rest}
      type={type}
      className={clsx(styles.root, styles[variant], styles[size], styles[color])}
      ref={ref}
    >
      {composeRenderProps(childrenFromProps, (children, { isPending, isDisabled }) => (
        <ButtonContent
          startIcon={startIcon}
          endIcon={endIcon}
          variant={variant}
          color={color}
          isPending={isPending}
          isDisabled={isDisabled}
          isContentVisuallyHidden={isContentVisuallyHidden}
        >
          {isContentVisuallyHidden ? <VisuallyHidden>{children}</VisuallyHidden> : children}
        </ButtonContent>
      ))}
    </ReactAriaButton>
  );
});
